import api from './api';

export type Product = {
  _id: string;
  name: string;
  unit: 'Mtrs' | 'Nos' | 'PCS' | 'Manual';
  mrp: number;
  category: string;
  no?: string;
  itemClass?: string;
  hsncode?: string;
  gstpercentage?: string | number;
};

export async function searchProductsDirect(q: string) {
  const res = await api.get<Product[]>('/products/search', { params: { q } });
  return res.data;
}

export async function searchProductsFilter(category: string, q: string) {
  const res = await api.get<Product[]>('/products/search', { params: { mode: 'filter', category, q } });
  return res.data;
}

export async function uploadProductsExcel(file: File) {
  const form = new FormData();
  form.append('file', file);
  const res = await api.post('/products/upload/excel', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  return res.data as { message: string; count: number };
}


